import { render, staticRenderFns } from "./PorCategoria.vue?vue&type=template&id=e9dcd7f2&scoped=true"
import script from "./PorCategoria.vue?vue&type=script&lang=js"
export * from "./PorCategoria.vue?vue&type=script&lang=js"
import style0 from "./PorCategoria.vue?vue&type=style&index=0&id=e9dcd7f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9dcd7f2",
  null
  
)

export default component.exports